exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wizard-item[data-v-eedd7e5a]{height:64px}.wizard-item__text[data-v-eedd7e5a]{color:#222!important}.wizard-item--active[data-v-eedd7e5a],.wizard-item[data-v-eedd7e5a]:hover{background-color:#ecf7f8}", ""]);

// exports
